import { ApplicationData } from "../ls2pac/ApplicationData";

export const DialogManagerConfig = (function() {
	
	return {
		getBaseConfig: function() {
			return {
				cancelText:	ApplicationData.language.cancel,
				okText:		ApplicationData.language.ok
			};
		}
	}
	
})();